import { render, staticRenderFns } from "./DigitalVillage.vue?vue&type=template&id=f8e15120"
import script from "./DigitalVillage.vue?vue&type=script&lang=js"
export * from "./DigitalVillage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports